import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import Amplify from "aws-amplify";
import "@aws-amplify/ui-vue";
import aws_exports from "./aws-exports";
import store from "./store";
// import VueApollo from "vue-apollo";
// import AWSAppSyncClient from "aws-appsync";

Amplify.configure(aws_exports);

Vue.config.productionTip = false;

// const client = new AWSAppSyncClient(config, options)
// const appsyncProvider = new VueApollo({
//  defaultClient: client
// })

// Vue.use(VueApollo);

new Vue({
  store,
  router,
  render: h => h(App)
  // apolloProvider: appsyncProvider
}).$mount("#app");
